<template>
  <div id="app">
    <template>
      <a-layout id="components-layout-demo-custom-trigger">
        <a-layout-sider
        width="240"
        breakpoint="lg"
        collapsed-width="0"
        @collapse="onCollapse"
        >
          <div class="addChat">
            <a-button block size="large" @click="handleAddChat">
              <div style="padding-right:50px">
                <a-icon type="user-add" style="padding-right:10px" />
                创建新聊天
              </div>
            </a-button>
          </div>
          <chat-switch
          v-for="(item, index) in chatHistory"
          :key="index"
          :name="item.name"
          :id="item.id"
          :current="currentId"
          @emitChatSetting="emitChatSetting"
          @emitChatSwitch="emitChatSwitch"
          @emitChatDelete="emitChatDelete"
          >
          </chat-switch>
          <div v-if="grade_id == 1" class="user-info">
            <div>试用次数剩余：{{trial_num}}次</div>
            <a target="_blank" href="https://hiplot.com.cn/vip">点击购买会员，享无限畅聊</a>
          </div>
        </a-layout-sider>
        <a-layout>
          <a-layout-content class="content">
            <running-chat :collapsed="collapsed" :chatData="currentChat" :loading="loading" @emitSubmit="handleChat" @emitRefresh="handleRefresh" @emitStop="handleAbort" :profile_url="profile_url" :userID="userID" :nickname="nickname" ></running-chat>
            <a-modal v-model="visible" title="聊天配置" @ok="handleOk">
              <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-form-model-item prop="name">
                  <span slot="label">
                    聊天名称&nbsp;
                    <a-tooltip title="左侧菜单栏显示的聊天名称，不影响功能">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-input
                    v-model="form.name"
                    :maxLength="8"
                    placeholder="请输入想在左侧显示的聊天名称"
                  />
                </a-form-model-item>
                <a-form-model-item>
                  <span slot="label">
                    模型版本&nbsp;
                    <a-tooltip title="使用的人工智能模型的版本">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <span class="ant-form-text">
                    3.5
                  </span>
                </a-form-model-item>
                <a-form-model-item prop="context">
                  <span slot="label">
                    上下文数量&nbsp;
                    <a-tooltip title="增加该参数能够让AI记得之前说过的话, 1000大约对应500个汉字, 若出现回复文字变少或答非所问, 请将该参数设置为0。">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-select
                    v-model="form.context"
                    placeholder="请选择上下文的数量"
                  >
                    <a-select-option value="0">
                      0
                    </a-select-option>
                    <a-select-option value="1000">
                      1000
                    </a-select-option>
                    <a-select-option value="2000">
                      2000
                    </a-select-option>
                    <a-select-option value="3000">
                      3000
                    </a-select-option>
                    <a-select-option value="5000">
                      5000
                    </a-select-option>
                    <a-select-option value="8000">
                      8000
                    </a-select-option>
                    <a-select-option value="10000">
                      10000
                    </a-select-option>
                    <a-select-option value="12000">
                      12000
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item>
                  <span slot="label">
                    角色设定&nbsp;
                    <a-tooltip title="设定人工智能的角色，请简化描述，例如'你说英文'">
                      <a-icon type="question-circle-o" />
                    </a-tooltip>
                  </span>
                  <a-input
                    v-model="form.setting"
                    :maxLength="12"
                    placeholder="请输入AI人物设定"
                  />
                </a-form-model-item>
              </a-form-model>
            </a-modal>  
            <div v-if="purchase" class="mask">
              <div class="show">
                <a-space align="start" :size="8">
                  <a target="_blank" href="https://hiplot.com.cn/vip">
                    <div class="img">试用次数剩余：{{trial_num}}次</div>
                  </a>
                  <div class="close-btn-svg" @click.stop="handleClose" >
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="16" cy="16" r="16" fill="black" fill-opacity="0.2"/>
                    <path d="M17.1542 15.9994L23.0136 9.01507C23.1118 8.899 23.0292 8.72266 22.8774 8.72266H21.0962C20.9913 8.72266 20.8908 8.76953 20.8216 8.84989L15.989 14.611L11.1564 8.84989C11.0895 8.76953 10.989 8.72266 10.8819 8.72266H9.10063C8.94884 8.72266 8.86625 8.899 8.96446 9.01507L14.8238 15.9994L8.96446 22.9838C8.94246 23.0097 8.92835 23.0413 8.9238 23.075C8.91924 23.1086 8.92444 23.1429 8.93878 23.1737C8.95312 23.2045 8.97599 23.2305 9.00467 23.2487C9.03336 23.2669 9.06666 23.2764 9.10063 23.2762H10.8819C10.9868 23.2762 11.0872 23.2294 11.1564 23.149L15.989 17.3878L20.8216 23.149C20.8886 23.2294 20.989 23.2762 21.0962 23.2762H22.8774C23.0292 23.2762 23.1118 23.0999 23.0136 22.9838L17.1542 15.9994Z" fill="white"/>
                    </svg>
                  </div>
                </a-space>
              </div>
            </div>
            <a-modal :visible="overLimit" :footer="null" @cancel="handleClose">
              <div style="font-size:16px;padding:20px;color:#000000;font-weight:600;">
                <div>系统检测到您的使用行为异常，暂时无法继续使用</div>
                <div>若有疑问，请扫描下方二维码，添加微信获取更多信息</div>
                <img src="@/assets/wechat.png" style="width:30%;display:block;margin:10px auto;" />
              </div>
            </a-modal>  
            <a-modal :visible="delConfirm" @ok="handleDelete" @cancel="handleCloseDel">
              <div style="font-size:16px;padding:20px;">
                <div>删除后不可恢复，是否确定删除？</div>
              </div>
            </a-modal>  
          </a-layout-content>
        </a-layout>
      </a-layout>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button, Layout, Icon, Row, Col, Steps, PageHeader, Select, List, Avatar, Modal, FormModel, Tooltip, message, Space } from 'ant-design-vue'
import RunningChat from './components/RunningChat.vue'
import ChatSwitch from './components/ChatSwitch.vue'
import axios from 'axios'
import Cookie from 'js-cookie'
import { fetchEventSource } from '@microsoft/fetch-event-source';

axios.defaults.baseURL = 'https://hiplotdebug202210132011.hiplot.com.cn/hiplot-chatgpt-api'
const sseURL = 'https://hiplotdebug202210132011.hiplot.com.cn/hiplot-chatgpt-api/chat'

Vue.use(Button)
Vue.use(Layout)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Steps)
Vue.use(PageHeader)
Vue.use(Select)
Vue.use(List)
Vue.use(Avatar)
Vue.use(Modal)
Vue.use(FormModel)
Vue.use(Tooltip)
Vue.use(Space)
Vue.prototype.$message = message

message.config({
    duration: 5,// 持续时间
    top:`50px`, // 到页面顶部距离
    maxCount: 3 // 最大显示数, 超过限制时，最早的消息会被自动关闭
});

export default {
  name: 'App',
  components: { 
    RunningChat,
    ChatSwitch
  },
  data() {
    return {
      collapsed: false,
      chatHistory: [],
      visible: false,
      currentChat: {},
      currentId: '',
      currentEditId: '',
      form: {
        name: '新聊天窗口',
        context: 5000,
        setting: ''
      },
      rules: {
        name: [{ required: true, message: '请输入一个聊天名称!' }],
        context: [{ required: true, message: '请选择上下文数量!'}]
      },
      loading: false,
      profile_url: '',
      nickname: '用户',
      userID: '',
      grade_id: 1,
      trial_num: 0,
      purchase: false,
      delConfirm: false,
      delID: '',
      overLimit: false,
      member_balance: 1,
      historyVersion: 1,
      abortController: null
    }
  },
  computed: {
  },
  methods: {
    onCollapse(collapsed) {
      this.collapsed = collapsed
    },
    randomString(len){
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      var tempLen = chars.length, tempStr=''
      for(var i=0; i<len; ++i){
        tempStr += chars.charAt(Math.floor(Math.random() * tempLen ))
      }
      return tempStr
    },
    getId() {
      let date = Date.now();
      let id = this.userID + '_N' + date + '_' + this.randomString(3);
      return id;
    },
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const index = this.chatHistory.findIndex(history => history.id == this.currentEditId)
          const chat = this.chatHistory[index]
          chat.name = this.form.name
          chat.context = this.form.context
          chat.setting = this.form.setting
          this.$set( this.chatHistory, index, chat )
          this.currentEditId = ''
          this.visible = false
          this.saveData(true)
        } else {
          return false;
        }
      })
    },
    emitChatSetting(id) {
      const result = this.chatHistory.find(history => history.id == id)
      this.form.name = result.name
      this.form.context = result.context
      this.form.setting = result.setting
      this.currentEditId = id
      this.visible = true
    },
    emitChatSwitch(id) {
      this.currentId = id
      const chat = this.chatHistory.find(history => history.id == id)
      this.currentChat = chat
    },
    emitChatDelete(id) {
      if (this.chatHistory.length < 2) {
        return
      }
      this.delConfirm = true
      this.delID = id
    },
    handleDelete() {
      this.chatHistory = this.chatHistory.filter(item => item.id != this.delID)
      this.emitChatSwitch(this.chatHistory[0].id)
      this.saveData(true)
      this.delConfirm = false
    },
    handleCloseDel() {
      this.delConfirm = false
    },
    handleAddChat() {
      if (this.chatHistory.length < 5 && this.chatHistory.length > 0) {
        const initChat = {
          id: this.getId(),
          name: '新聊天窗口',
          context: 5000,
          setting: '',
          data: [],
          init: true
        }
        this.chatHistory.push(initChat)
        this.currentChat = initChat
        this.currentId = initChat.id
        this.saveData(true)
      }
    },
    handleChat(data, alter = {}) {
      if (this.grade_id == 1 && this.trial_num < 1) {
        this.purchase =true
        return
      } else if (this.grade_id != 1 && this.member_balance == 0) {
        this.overLimit = true
        return
      }
      if (this.userID) {
        this.loading = true

        const index = this.chatHistory.findIndex(history => history.id == this.currentId)
        if (this.chatHistory[index].init) { 
          if (this.chatHistory[index].name === '新聊天窗口') {
            this.chatHistory[index].name = data.substring(0,8)
          }
          this.chatHistory[index].init = false
        }
        this.chatHistory[index].data.push({type: 'send', content: data})
        this.currentChat = this.chatHistory[index]
        this.saveData(true)

        const request = this.postDataAssemble(this.currentChat)
        let _this = this
        const requestBody = JSON.stringify(request).replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/&/g, '\\u0026')

        this.abortController = new AbortController()
        const signal = this.abortController.signal
        fetchEventSource(sseURL, {
          signal: signal,
          method: 'POST',
          headers: {
            "Content-Type": 'application/json',
            'Authorization': this.getAuthorization()
          },
          body: requestBody,
          openWhenHidden: true,
          onmessage(event) {
            if (event.event === 'error') {
              _this.saveData(true)
              _this.loading = false
              _this.$message.warning(event.data);
              throw new Error(event.data);
            }
            _this.handleMessage(event, alter)
          },
          onclose() {
            _this.saveData(true)
            _this.loading = false
          },
          onerror(err) {
            console.log(err)
            _this.saveData(true)
            _this.loading = false
            _this.$message.warning('服务器错误，请稍后再试');
            throw err
          }
        })
      } else {
        this.$message.error('获取用户信息失败，请检查登录状态或刷新重试');
      }
    },
    handleRefresh() {
      for (var i = this.currentChat.data.length - 1; i >= 0; i--) {
        if (this.currentChat.data[i].type === "send") {
          const data = this.currentChat.data[i].content
          var alter = {}
          if (this.currentChat.data[i+1] && this.currentChat.data[i+1].type && this.currentChat.data[i+1].type === "receive") {
            const lastReceive = this.currentChat.data[i+1]
            for(let key in lastReceive) {
              if (key === 'content') {
                this.$set(alter,"content1",lastReceive.content)
              } else if (key.includes('content')) {
                this.$set(alter,"content" + (Number(key.replace(/[^\d]/g, " ")) + 1),lastReceive[key])
              }
            }
          }
          this.currentChat.data = this.currentChat.data.slice(0, i)
          this.handleChat(data, alter)
          break
        }
      }
    },
    handleAbort() {
      this.abortController.abort()
      this.saveData(true)
      this.loading = false
    },
    handleMessage(event, alter) {
      if (event.event === 'new') {
        const requestIndex = this.chatHistory.findIndex(history => history.id == event.id)
        if (requestIndex !== -1) {
          if (JSON.stringify(alter) == "{}") {
            this.chatHistory[requestIndex].data.push({type: 'receive', content: ''})
          } else {
            this.chatHistory[requestIndex].data.push({type: 'receive', content: '', ...alter})
          }
          this.currentChat = this.chatHistory[requestIndex]
          this.currentId = this.currentChat.id
        }
      } else if (event.event === 'add') {
        const requestIndex = this.chatHistory.findIndex(history => history.id == event.id)
        if (requestIndex !== -1) {
          const length = this.chatHistory[requestIndex].data.length
          this.chatHistory[requestIndex].data[length - 1].content = this.chatHistory[requestIndex].data[length - 1].content + event.data.replaceAll('\\n', '\n')
          this.currentChat = this.chatHistory[requestIndex]
          this.currentId = this.currentChat.id
        }
      } else if (event.event === 'stop') {
        this.saveData(false)
        this.loading = false
      } else  if (event.event === 'error') {
        this.saveData(false)
        this.loading = false
        this.$message.warning(event.data);
      } else {
        this.saveData(false)
        this.loading = false
        this.$message.warning('服务器错误，请稍后再试');
      }
    },
    saveData(upload) {
      setTimeout(this.getUseLimit, 500)
      this.historyVersion = Math.round(Date.now()/1000)
      if (this.userID) {
        localStorage.setItem('hiplot_chatgpt_history_' + this.userID, JSON.stringify(this.chatHistory))
        localStorage.setItem('hiplot_chatgpt_history_version_' + this.userID, this.historyVersion)
      } else {
        this.$message.error('获取用户信息失败，请检查登录状态或刷新重试');
      }
      if (upload && this.grade_id != 1) {
        axios.post('chat/history', {uuid:this.userID, history:JSON.stringify(this.chatHistory), version:this.historyVersion}, {headers: {'Content-Type': 'application/json', 'Authorization': this.getAuthorization()}})
        .then((res)=> {
          if (res.data.code != 200) {
            this.$message.error('存入云端历史失败');
          }
        }).catch(error => {
          console.log(error)
          this.$message.error('存入云端历史失败');
        })
      }
    },
    getData() {
      if (this.userID) {
        let restore = JSON.parse(localStorage.getItem('hiplot_chatgpt_history_' + this.userID))
        let version = JSON.parse(localStorage.getItem('hiplot_chatgpt_history_version_' + this.userID))
        if (!version) {
          version = 1
        }
        if (this.grade_id != 1) {
          axios.get('chat/history', {headers: {'Content-Type': 'application/json', 'Authorization': this.getAuthorization()}}).then((res)=> {
            if (res) {
              let cloudHistory = JSON.parse(res.data.data.history)
              let cloudVersion = res.data.data.version
              if (cloudVersion >= version && cloudHistory.length > 0) {
                restore = cloudHistory
                version = cloudVersion
              }
              if (restore) {
                this.chatHistory = restore
                this.historyVersion = version
                this.currentId = this.chatHistory[0].id
                this.currentChat = this.chatHistory[0]
              } else {
                const initChat = {
                  id: this.getId(),
                  name: '新聊天窗口',
                  context: 5000,
                  setting: '',
                  data: [],
                  init: true
                }
                this.chatHistory.push(initChat)
                this.historyVersion = version
                this.currentId = initChat.id
                this.currentChat = initChat
              }
            }
          }).catch(error => {
            console.log(error)
            this.$message.error('获取云端历史失败，载入本地记录');
          })
        } else {
          if (restore) {
            this.chatHistory = restore
            this.historyVersion = version
            this.currentId = this.chatHistory[0].id
            this.currentChat = this.chatHistory[0]
          } else {
            const initChat = {
              id: this.getId(),
              name: '新聊天窗口',
              context: 5000,
              setting: '',
              data: [],
              init: true
            }
            this.chatHistory.push(initChat)
            this.historyVersion = version
            this.currentId = initChat.id
            this.currentChat = initChat
          }
        }
      } else {
        this.$message.error('获取用户信息失败，请检查登录状态或刷新重试');
        return null
      }

    },
    postDataAssemble(data) {
      const postData = {}
      postData.id = data.id
      postData.use_type = 0
      postData.context = String(data.context)
      postData.model = 'gpt-3.5-turbo'
      postData.history = []
      if (data.setting) {
        postData.history.push({role: 'system', content: data.setting})
      }
      for (let i = 0; i < data.data.length - 1; i++) {
        postData.history.push({role: data.data[i].type==='send'?'user':'assistant', content: data.data[i].content})
      }
      postData.message = {role: 'user', content: data.data[data.data.length - 1].content}
      return postData
    },
    getAuthorization() {
      return Cookie.get('Authorization')
    },
    handleClose() {
      this.purchase = false
      this.overLimit = false
    },
    getUseLimit() {
      let toolType
      if (this.grade_id == 1) {
        toolType = 1
      } else {
        toolType = 3
      }
      axios.get('limit/' + toolType, {headers: {'Content-Type': 'application/json', 'Authorization': this.getAuthorization()}}).then((useLimit)=> {
        this.trial_num = useLimit.data.data.trial_balance
        this.member_balance = useLimit.data.data.member_balance
        if (this.grade_id != 1 && this.member_balance == 0) {
          this.overLimit = true
        }
      }).catch(error => {
        console.log(error)
        this.$message.error('获取用户信息失败，请检查登录状态或刷新重试');
      })
    }
  },
  mounted() {
    axios.get('member-my', {headers: {'Content-Type': 'application/json', 'Authorization': this.getAuthorization()}})
    .then((response)=> {
      if (response.data.msg === 'ok') {
        this.profile_url = response.data.data.profile_url
        this.nickname = response.data.data.nick_name
        this.userID = response.data.data.uuid
        this.grade_id = response.data.data.grade_id
        this.getUseLimit()
        if (this.grade_id == 1) { 
          this.purchase = true
        }
        this.getData()
      } else {
        this.$message.error('获取用户信息失败，请检查登录状态或刷新重试');
      }

    }).catch(error => {
      console.log(error)
      this.$message.error('获取用户信息失败，请检查登录状态或刷新重试');
    })
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

#components-layout-demo-custom-trigger {
  height: 100%;
}

#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

.content {
  height: 100%;
  overflow: auto;
}

.addChat{
  padding: 10px;
}

.user-info{
  padding: 16px;
  position:fixed; 
  bottom:0;
  color:aliceblue;
  font-size: 16px;
}

.mask{
  visibility: visible;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  padding-top: 126px;
}

.show{
  height: 540px;
}

.img{
  height: 540px;
  width: 438px;
  cursor:pointer;
  padding: 30px;
  color: red;
  font-size: 24px;
  font-weight: 500;
  background: url(./assets/adv.png);
}

.close-btn-svg{
  cursor:pointer;
  position: relative;
  top: 0px;
  font-size: 32px;
}
</style>
